<template>
    <div class="container px-0">

        <div class="row">
            <div class="col-12 col-sm-6">
				<h5 class="text-secondary">Section Title</h5>
				<input type="text" class="form-control" placeholder="Enter Title" v-model="questionnaireData.title">
			</div>
        </div>
		<div class="row mt-4">
			<div class="col-12 col-sm-6">
				<h5 class="text-secondary">Questions</h5>

				<div class="form-group mt-3">
					<draggable v-model="questionnaireData.questions">
						<transition-group name="list-transition">
							<div
								v-for="(question, index) in questionnaireData.questions"
								class="flex-table flex-table-shadow"
								:key="null || index"
							>
								<div class="flex-table--row flex-table--row--no-padding-y">
									<div class="flex-table--cell">
										<img :src="'/svg/' + resource_group + '/drag.svg'" alt="">
									</div>
									<div class="flex-table--cell flex-table--cell-grow-always">
										<input type="text" class="form-control border" placeholder="Enter a question" v-model="question.title">
									</div>
									<div class="flex-table--cell">
										<svg-image
											:src="'/svg/' + resource_group +'/bin.svg'"
											width="20px"
											height="20px"
											highlight="negative"
											:auto_hover="true"
											:spaced="false"
											@click="deleteQuestion(index)"
										></svg-image>
									</div>
								</div>
							</div>
						</transition-group>
					</draggable>
				</div>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-12">
				<a href="javascript:void(0)" class="btn btn-primary" @click="addQuestion()">+ Add Question</a>
			</div>
		</div>

    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        name: "QualityAssuranceQuestionnaireCreateEditPage",

        components: {
            draggable
        },

        props: {
            method: {
                type: String,
                default: 'post'
            },
            submitUrl: {
                type: String,
                required: true
            },
            deleteUrl: {
                type: String,
                required: true
            },
            redirectUrl: {
                type: String,
                required: true
            },
            questionnaire: {
                type: Object,
                default: () => { return {} }
            }
        },

        data(){
            return {
                questionnaireData: {
                    title: '',
                    questions: []
                },

                saving: false,

                errors: []
            }
        },

        beforeMount() {
            this.questionnaireData = {...this.questionnaireData, ...this.questionnaire};

            if (!this.questionnaireData.questions.length)
				this.questionnaireData.questions.push({
					title: ''
				});

            window.addEventListener('LAYOUT:primary_button', this.save);
            window.addEventListener('LAYOUT:cancel_button', this.cancel);
        },

        methods: {
            save: function(){
                this.errors = [];

                if (this.saving){
					return false;
                }

				this.saving = true;

                axios({
                    'method': this.method,
                    'url': this.submitUrl,
                    'data': this.questionnaireData
                }).then(() => {
                    this.saving = false;
                    window.location.href = this.redirectUrl;
                }).catch(error => {
                    if(error.response.data.errors !== undefined){
                        Object.values(error.response.data.errors).forEach((err, i) => {
                            this.errors.push(`<li>${err[0]}</li>`);
                        });
                    }

                    if (this.errors.length >= 2) {
                        Vue.$toast.open({
                            message: `There were ${this.errors.length} errors: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    } else if (this.errors.length === 1) {
                        Vue.$toast.open({
                            message: `There was an error: ${this.errors.join('')}`,
                            type: 'error'
                        });
                    }

                    this.saving = false;
                });
            },

            cancel(){
                window.location.href = this.redirectUrl;
            },

            addQuestion: function(){
                this.questionnaireData.questions.push({
                    title: ''
                });
            },

            deleteQuestion: function(index){
				Vue.delete(this.questionnaireData.questions, index);

                Vue.$toast.open({
                    message: 'Question Deleted',
                    type: 'success'
                });
            }
        },

        computed: {
            resourceGroup: () => {
                return window.resource_group;
            }
        }
    }
</script>
